<script lang="ts">
    import type { DesignEditor } from '$src/application/designs/DesignEditor';
    import { DesignScene } from '$src/domain/designs/DesignScene';
    import { SceneViewCanvas } from '$src/infrastructure/designs/editor/SceneViewCanvas';
    import { onMount, onDestroy, setContext, getContext } from 'svelte';
    //import { designSceneContext } from './DesignSceneContext.js';
   
    const editor : DesignEditor = getContext('editor');
    let sceneViewCanvas: SceneViewCanvas;
    
    //var designScene : DesignScene = getContext('scene');
    //console.log('myscene : ' + designScene.text);

    function init() {
     
        let container = document.getElementById('three-container');

        sceneViewCanvas = new SceneViewCanvas(new DesignScene(), container!);
        sceneViewCanvas.initialize();
        editor.setSceneViewCanvas(sceneViewCanvas);
        
        //const designSceneController = new DesignSceneController(designScene, sceneViewCanvas);
        
        //
        //designSceneContext.set(designScene);
    }
  
    onMount(init);

    onDestroy(() => {
    });
  </script>
  
  <style>
    #three-container {
      width: 100%;
      height: 100%;
    }
  </style>
  
  <div id="three-container">
  </div>
  